export class StringUtilities {

    static formatPhoneNumber(phoneNumber: string): string {
        return `${phoneNumber.substring(0, 4)} ${phoneNumber.substring(4, phoneNumber.length)}`;
    }

}
